import React from 'react';
import './ThreeDSChallenge.scss';

const ThreeDSChallenge = ({ challenge, verifying }) => {
  if (!challenge?.acs_url) return null;

  return (
    <div className="ThreeDSChallenge">
      <div className="three_ds__title">Verificação do seu banco</div>
      <div className="three_ds__description">
        Confirme a compra com o seu banco para concluir o pagamento.
      </div>

      <iframe
        className="three_ds__frame"
        src={challenge.acs_url}
        title="Verificação do seu banco"
      />

      {verifying ? (
        <div className="three_ds__status">Confirmando o pagamento...</div>
      ) : null}
    </div>
  );
};

export default ThreeDSChallenge;
